export default (state = {}, action) => {
    let { type, payload } = action
    switch (type) {
        case 'MARKER_CENTER':
            return payload
        case 'MARKER_CENTER_REMOVE':
            return null
        default:
            return state
    }
}